import { createScheduleComponent, duration } from '@play-co/components';
import { Match2Reward } from '../match2/rewards/match2-rewards.ruleset';

/**
 * Puzzle level that leaderboards should be available from
 */
export const weeklyLeaderboardUnlockLevel = 44;

/**
 * Maximum size of a weekly leaderboard.
 */
export const weeklyLeaderboardSize = 30;

/**
 * The init date for the feature
 */
export const WEEKLY_LEADERBOARD_INIT_DATE = '2025-03-23T23:00:00.000+09:00';

/**
 * Leaderboards weekly schedule
 */
export const weeklyLeaderboardSchedule = createScheduleComponent(
  WEEKLY_LEADERBOARD_INIT_DATE,
  'Asia/Tokyo',
  {
    weekly: [{ day: 'Sunday', time: '23:00', duration: { days: 7 } }],
  },
);

/**
 * Weekly leaderboard points per puzzle win stars
 */
export const weeklyLeaderboardStarScoreMap: Record<number, number> = {
  1: 3,
  2: 5,
  3: 10,
};

/**
 * Weekly leaderboard reward per player position.
 */
export const weeklyLeaderboardRewards: Match2Reward[][] = [
  // 1st Place
  [
    {
      type: 'powerups',
      subType: 'rocket',
      duration: duration({ minutes: 60 }),
    },
    { type: 'powerups', subType: 'bomb', duration: duration({ minutes: 60 }) },
    { type: 'powerups', subType: 'cube', duration: duration({ minutes: 60 }) },
    { type: 'gems', amount: 200 },
  ] as const,

  // 2nd Place
  [
    { type: 'powerups', subType: 'bomb', duration: duration({ minutes: 30 }) },
    { type: 'powerups', subType: 'cube', duration: duration({ minutes: 30 }) },
    { type: 'gems', amount: 100 },
  ] as const,

  // 3rd Place
  [
    {
      type: 'powerups',
      subType: 'rocket',
      duration: duration({ minutes: 15 }),
    },
    { type: 'powerups', subType: 'bomb', duration: duration({ minutes: 15 }) },
    { type: 'gems', amount: 50 },
  ] as const,
] as const;

/**
 * Maximum number of players to be displayed in the global ranking
 */
export const weeklyLeaderboardGlobalRankingSize = 1000;

/**
 * Expiration time for old weekly leaderboards
 */
export const weeklyLeaderboardExpirationTime = duration({ days: 14 });
